import { Box, Heading, Image, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import gifImg from "../Images/aboutGIF.gif"
const About = () => {
  return (
    <Box p={{ base: "10px", lg: "30px" }}>
      <Box pt="10px">
        <Heading color="#00ade7" size="lg">
          About Me
        </Heading>
      </Box>
      <SimpleGrid
        justify="center"
        align="center"
        templateColumns={{ base: "auto", lg: "repeat(2,1fr)" }}
        gap={{ base: "10px", lg: "50px" }}
        mt={{ base: "10px", lg: "100px" }}
      >
        <Box>
          <Image
            src={gifImg}
            alt="creative image"
          />
        </Box>
        <Box textAlign="justify" fontSize={["xs", "sm", "md", "lg"]}>
          <Text textIndent="1.5rem">
            Passionate about creating solutions that solve problems and
            contribute to a better future, I am a dedicated full-stack web
            developer. With expertise in NodeJS, ExpressJS, MongoDB, Mongoose,
            ReactJS, JavaScript, HTML, and CSS, I focus on delivering scalable
            products designed for optimal user interaction.
          </Text>
          <Text textIndent="1.5rem">
            Embracing a goal-oriented approach, my recent accomplishments
            include the collaborative development of a fully functional
            e-commerce platform with a team of five members.
          </Text>
          <Text textIndent="1.5rem">
            My skill set proficiency in writing efficient code, meticulous
            attention to detail, and communication abilities. I am driven by the
            opportunity to leverage these skills and experiences to create
            innovative solutions that align with business objectives.
          </Text>
          <Text textIndent="1.5rem">
            As an aspiring full-stack web developer, I am eager to contribute to
            company growth and advance my career in roles that allow me to
            directly impact the digital landscape.
          </Text>
        </Box>
      </SimpleGrid>
    </Box>
  );
};

export default About;
